import template from './pageNotAvailable.html';

// The default export returns the component details object to register with KO
export default { template: template };